import React, { useEffect, useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  formatDateByLocaleShort,
  getCurrency,
} from "../../../helper/Formatter.js";
import swal from "sweetalert";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import moment from "moment";


import { getLoginDetailService } from "../../../API/eventApi.js";
import Spinner from "../../Spinner/index.js";
import { getCoupon } from "../../../API/couponApi.js";
import { getPolicy } from "../../../API/policyApi.js";
import { getBookRates } from "../../../API/rateplanApi.js";
import { getWallet } from "../../../API/walletApi.js";
import CustModal from "../../Modal/CustModal.js";
import { createGuestService } from "../../../API/guest.js";
import { calculatePaymentAmounts, countDaysBetweenDates, isCheckInWithinDays } from "../../commonFun.js";

export default function RoomFile({ setShowErr, ...props }) {
  let branchData = props.branchData
  // console.log('props::: ', props);
  let userType = localStorage.getItem("LoginUserType");
  let locale = localStorage.getItem("Locale");
  let currency = localStorage.getItem("Currency");
  const location = useLocation();
  const navigate = useNavigate();
  const loginUserId = localStorage.getItem("LoginUserId");
  const branchId = localStorage.getItem("branchid");
  const loginUserType = localStorage.getItem("LoginUserType");
  const compName = localStorage.getItem("branchname");
  const tabs = ["events", "room", "service"];
  const [formData, setFormData] = useState({
    password: "",
    email: "",
  });
  const [couponData, setCouponData] = useState([]);
  const [couponCode, setCouponCode] = useState("");
  const [finalCoupon, setFinalCoupon] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [allPayloadData, setAllPayloadData] = useState(location?.state?.data);

  const [walletAllData, setWalletAllData] = useState(null);
  const [extraCloseModal, setExtraCloseModal] = useState(false);
  const [infoExtraChildAdult, setInfoExtraChildAdult] = useState({});
  const [isBookingInfoExpanded, setIsBookingInfoExpanded] = useState(true);
  const [isBookingPolicyInfoExpanded, setIsBookingPolicyInfoExpanded] =
    useState(true);
  const [guestFormData, setGuestFormData] = useState({});
  const [storePolicyData, setStorePolicyData] = useState([]);
  const [bookData, setBookData] = useState(location?.state);

  const grandTotal = Number(Number(props.bookDetailsData?.grandtotal || 0).toFixed(2))
  // console.log('props.bookDetailsData?::: ', props.bookDetailsData);

    const advancePercentages = Number(props.branchData?.appointmentsetting?.booking_advance_percentage || 0);
    // console.log('advancePercentages::: ', advancePercentages);
    const advDays =   Number(props.branchData?.appointmentsetting?.booking_advance_days || 0);

    const {
      total,
      advanceAmount,
      remainingAmount,
      advancePercentage: advPercent,
      remainingPercentage,
    } = calculatePaymentAmounts(grandTotal, advancePercentages , advDays);

    const insideDaysLimit = isCheckInWithinDays(advDays)
  // const numberOfDays = countDaysBetweenDates()
  // console.log('numberOfDays::: ', numberOfDays);


    // console.log('remainingPercentage::: ',  total,
    //   advanceAmount,
    //   remainingAmount,
    //   remainingPercentage);


  // const total = Number(
  //   Number(props.bookDetailsData?.grandtotal || 0).toFixed(2)
  // );

  // const advancePercentage = Number(branchData?.appointmentsetting?.booking_advance_percentage || 0);
  // const advanceAmount = Number(((total * advancePercentage) / 100).toFixed(2));
  // console.log('total::: ', total);
  // const remainingPercentage = 100 - advancePercentage;
  // const remainingAmount = Number(((total * remainingPercentage) / 100).toFixed(2));



  const fetchLoginDetails = async (id, schemaName) => {
    try {
      setIsLoader(true);
      const { data } = await getLoginDetailService(id, schemaName)

      setFormData({
        fullName: data?.property?.fullname || "",
        email: data?.property?.primaryemail || "",
      });

      return data;
    } catch (error) {
      setIsLoader(false);
      console.error("Error fetching login details:", error);
    } finally {
      setIsLoader(false);
    }
  };

  const fetchData = async (apiCall, ...params) => {
    try {
      const response = await apiCall(...params);
      if (response?.status === 200 && response != null) {
        return response?.data;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    return null;
  };

  const handleBookRoomRatePlan = (payload) => {
    return getBookRates(payload);
  };

  const getAllPolicy = async () => {
    return getPolicy();
  };


  const getAllCoupon = async () => {
    return getCoupon();
  };

  const getWalletPoint = async () => {
    return getWallet(loginUserId);
  };



  useEffect(() => {
    const loadData = async () => {
      setIsLoader(true);
      try {
        const [couponData, policyData] = await Promise.all([
          fetchData(getAllCoupon),
          fetchData(getAllPolicy),
        ]);
        setCouponData(couponData);
        setStorePolicyData(policyData?.[0]);
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        setIsLoader(false);
      }
    };

    loadData();
  }, []);

  async function callWalletApi() {
    const res = await getWalletPoint(loginUserId);
    setWalletAllData(res?.data?.[0]);
  }

  useEffect(() => {
    if (loginUserId) {
      setDisabled(true);
      fetchLoginDetails(
        loginUserId,
        loginUserType === "Prospects" ? "prospects" : "Member"
      );
      // callWalletApi();
    }
  }, [loginUserId, loginUserType]);



  // console.log('loginUserType::: ', loginUserType);

  const handleApplyCouponCode = () => {
    let matchedCoupon = "";
    const couponCodeValue = couponCode?.property?.couponcode || couponCode;

    if (!couponCodeValue) {
      toast.error("Please add a coupon code.", {
        autoClose: 1000,
      });
      return;
    }

    matchedCoupon = couponData?.find(
      (item) =>
        item?.status === "active" &&
        item?.property?.couponcode.toLowerCase() ===
        couponCodeValue?.toLowerCase()
    );

    if (matchedCoupon) {
      setFinalCoupon(matchedCoupon);
      toast.success(`Coupon applied successfully!`, {
        autoClose: 1000,
        backgroundColor: "red",
      });
    } else {
      toast.error("Invalid coupon code.", {
        autoClose: 1000,
        backgroundColor: "red",
      });
    }
  };

  function handleOnchangeCouponCode(e) {
    setCouponCode(e.target.value);
  }

  function handleCouponVal(e, item) {
    e.preventDefault();
    setCouponCode(item);
  }

  function handleCancelCoupon(params) {
    setFinalCoupon(null);
  }



  async function handleFinalApiCall() {
    // console.log('props.guestFormData::: ', props.guestFormData);

    const { fullname, mobile, primaryemail } = props.guestFormData;

    if (loginUserId) {
      let finalPayloadData = {
        ...allPayloadData,
        charges: allPayloadData?.charges + allPayloadData?.taxamount,
        cost: allPayloadData?.charges + allPayloadData?.taxamount,
        guestDetails: props.guestFormData,
        customerid: loginUserId,
        onModel: "Member",
      };

      // Remove unitid and unit from occupants
      const newPayload = {
        ...finalPayloadData,
        bookingdetail: {
          ...finalPayloadData.bookingdetail,
          occupants: finalPayloadData.bookingdetail.occupants.map((occupant) => {
            const { unit, ...rest } = occupant;
            return rest;
          }),
        },
      };
      delete newPayload.unitid;

      // console.log('newPayload::: ', newPayload);

      try {
        setIsLoader(true);
        let lastPrice = {
          total: total,
          advanceAmount: advanceAmount,
          remainingAmount: remainingAmount,
        };


        handleBookRoomRatePlan(newPayload)
          .then((res) => {
            const facilitybooking = res;
            setIsLoader(false);

            localStorage.setItem("allPayloadData", JSON.stringify(newPayload));
            localStorage.setItem(
              "billDetails",
              JSON.stringify(props.bookDetailsData)
            );

            localStorage.setItem("appointmentData", JSON.stringify(res?.data));
            navigate("/" + compName + "/roomthankyou/paymentsummary", {
              state: {
                BookedRoomInfo: newPayload,
                billDetails: props.bookDetailsData,
                appointmentData: res?.data,
                lastPrice:lastPrice

              },
            });
            setIsLoader(false);
            localStorage.setItem("lastPrice", JSON.stringify(lastPrice));
          })
          .catch((error) => {
            setIsLoader(false);
            console.error("Error:", error);
          });
      } catch (error) {
        console.error("Error:", error);
        setIsLoader(false);
      }
    } else {
      if (props?.guestFormData?.fullname && ( props?.guestFormData?.type === "prospect" & props?.guestFormData?.IsValid === true)
      ) {
        let payload = {
          property: { ...props.guestFormData, category: "Prospect" },
          category: "Prospect",
        };

        try {
          setIsLoader(true);
          const response = await createGuestService(payload);

          if (response?.status === 200) {
            const data = response?.data;
            const category =
              data?.property?.category?.toLowerCase() || "prospect";

            // Local storage
            localStorage.setItem("prospectdata", JSON.stringify(data));
            localStorage.setItem("LoginUserType", category);
            localStorage.setItem("currency", data?.branchid?.currency);
            localStorage.setItem("locale", data?.branchid?.locale);

            // Session storage
            localStorage.setItem("LoginUserId", data?._id);
            localStorage.setItem("prospectdata", JSON.stringify(data));
            localStorage.setItem("LoginUserType", category);
            localStorage.setItem("currency", data?.branchid?.currency);
            localStorage.setItem("locale", data?.branchid?.locale);
            localStorage.setItem("fullname", data?.property?.fullname);

            let finalPayloadData = {
              ...allPayloadData,
              charges: props.bookDetailsData?.grandtotal,
              cost: props.bookDetailsData?.grandtotal,
              guestDetails: props.guestFormData,
              customerid: data?._id,
              onModel: "Member",
            };

            // Remove unitid and unit from occupants
            const newPayload = {
              ...finalPayloadData,
              bookingdetail: {
                ...finalPayloadData.bookingdetail,
                occupants: finalPayloadData.bookingdetail.occupants.map(
                  (occupant) => {
                    const { unit, ...rest } = occupant;
                    return rest;
                  }
                ),
              },
            };
            delete newPayload.unitid;

            newPayload.bookingdetail.actualcost =
              props.bookDetailsData?.grandtotal;
            newPayload.bookingdetail.bookingcost =
              props.bookDetailsData?.grandtotal;

            newPayload.bookingdetail.occupants =
              newPayload.bookingdetail.occupants.map((occupant) => ({
                ...occupant,
                taxes: [],
                realTax: [
                  {
                    Base: isNaN(occupant.taxes.Base) ? 0 : occupant.taxes.Base,
                    ExtraAdult: isNaN(occupant.taxes.ExtraAdult)
                      ? 0
                      : occupant.taxes.ExtraAdult,
                    ExtraChild: isNaN(occupant.taxes.ExtraChild)
                      ? 0
                      : occupant.taxes.ExtraChild,
                  },
                ],
              }));

            try {
              setIsLoader(true);

              handleBookRoomRatePlan(newPayload)
                .then((res) => {
                  const facilitybooking = res;
                  // console.log("res::: ", res?.data?.billid);
                  localStorage.setItem(
                    "allPayloadData",
                    JSON.stringify(newPayload)
                  );
                  localStorage.setItem(
                    "billDetails",
                    JSON.stringify(props.bookDetailsData)
                  );
                  localStorage.setItem(
                    "appointmentData",
                    JSON.stringify(res?.data)
                  );
                  navigate("/" + compName + "/roomthankyou/paymentsummary", {
                    state: {
                      BookedRoomInfo: newPayload,
                      billDetails: props.bookDetailsData,
                      appointmentData: res?.data,
                    },
                  });
                })
                .catch((error) => {
                  setIsLoader(false);
                  console.error("Error:", error);
                });
            } catch (error) {
              console.error("Error:", error);
              setIsLoader(false);
            }
          } else {
            toast.error(response?.data?.error || "Unexpected error", {
              autoClose: 1000,
            });
            setIsLoader(false);
          }
        } catch (error) {
          setIsLoader(false);
          console.error("error::: ", error);
        } finally {
          setIsLoader(false);
        }
      } else {
        toast.warn("Please login to book room", { autoClose: 1000 });
      }
    }
  }




  function handleOpenModal(params) {
    setExtraCloseModal(true);
    setInfoExtraChildAdult(params?.taxes);
  }




  const toggleBookingInfo = () => {
    setIsBookingInfoExpanded(!isBookingInfoExpanded);
  };





  const togglePolicyInfo = () => {
    setIsBookingPolicyInfoExpanded(!isBookingPolicyInfoExpanded);
  };


  return (
    <>
      {isLoader && <Spinner />}

      {/* Booking Details */}

      {/* <>
        {tabs.includes(location.state?.bookingtype) && (
          <div className="white-box background-transparent mb-4 p-xl-4">
            <div className="membroz-form wpcf7-form">
              <div
                className="d-flex mb-3 justify-content-between align-items-center cursor-pointer"
                onClick={toggleBookingInfo}
              >
                <h5 className="">Booking Information</h5>
                <i
                  className={`fa icon_color ${isBookingInfoExpanded
                    ? "fa-chevron-up"
                    : "fa-chevron-down"
                    }`}
                />
              </div>
              {isBookingInfoExpanded && (
                <>
                  <div className="d-flex justify-content-center">
                    <div className="col-6">
                      <label className="form-label">Check-in:</label>
                      <h6 className="card-title mb-1">
                        {allPayloadData?.checkin
                          ?
                          formatDateByLocaleShort(allPayloadData.checkin)

                          : "No Check-in Date"}
                      </h6>
                    </div>
                    <div className="col-6 border-left">
                      <label className="form-label">Check-out:</label>
                      <h6 className="card-title mb-1">
                        {allPayloadData?.checkin
                          ?
                          formatDateByLocaleShort(allPayloadData.checkout)
                          : "No Check-in Date"}
                      </h6>
                    </div>
                  </div>
                  <div className="mt-4 ">
                    <h5>Rooms & Rates</h5>
                    {allPayloadData?.bookingdetail?.occupants?.map(
                      (item, index) => {
                        return (
                          <div className="border-bottom p-3 mb-2" key={index}>
                            <h6 className="font-20 font-weight-normal">
                              Room {index + 1} :
                            </h6>
                            <p className="m-0">
                              {item?.roomName} - {item?.rateTypeName} included
                            </p>
                            <p>
                              <strong className="font-weight-normal">
                                Pax Details :
                              </strong>{" "}
                              {item?.adults} Adults, {item?.childrens} Children
                            </p>
                            <table className="table table-bordered">
                              <tbody>
                                <tr>
                                  <td>
                                    <strong>Room Rates Exclusive of Tax</strong>
                                  </td>
                                  <td className="text-end">
                                    {getCurrency()}&nbsp;
                                    {item?.actualcost}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        );
                      }
                    )}
                  </div>
                  <div className="col-xl-12 col-lg-12 col-md-12 mt-3"></div>
                </>
              )}
            </div>
          </div>
        )}
      </> */}

      {/* Policy Details */}

      <div className="white-box background-transparent p-xl-4 hotel_policy_container">
        <div className="membroz-form wpcf7-form">
          <div
            className="d-flex mb-3 justify-content-between align-items-center cursor-pointer"
            onClick={togglePolicyInfo}
          >
            <h5 className="">Hotel Policy & Booking Conditions</h5>
            <i
              className={`fa icon_color ${
                isBookingPolicyInfoExpanded
                  ? "fa-chevron-up"
                  : "fa-chevron-down"
              }`}
            />
          </div>

          {isBookingPolicyInfoExpanded && (
            <div>
              <p
                style={{ fontSize: 16 }}
                dangerouslySetInnerHTML={{
                  __html: storePolicyData?.property?.doctemplate,
                }}
              ></p>
            </div>
          )}
        </div>
      </div>

      <div className="book_btn_container_fixed-bottom">
        <p className="mb-0">
          Total amount : {getCurrency()}&nbsp;
           {(insideDaysLimit?.isWithinRange === true) ? total : advanceAmount }
        </p>
        <button
          onClick={handleFinalApiCall}
          className="btn font-20 font-weight-bold w-100 btn-primary book_now_btn_fixed -3"
        >
          Book now
        </button>
      </div>

      <CustModal
        modalWidthSize={"lg"}
        show={extraCloseModal}
        footerBtn={true}
        handleClose={() => setExtraCloseModal(false)}
        title="Room details"
        body={
          <>
            <h6 className="text-decoration-underline">
              {/* Extra Adult price : ₹ 2500{" "} */}
            </h6>
            <table className="table table-bordered table-striped">
              <thead className="thead-dark">
                <tr>
                  {/* <th scope="col">Date</th> */}
                  <th scope="col">Rates</th>
                  <th scope="col">Extra adult tax rates</th>
                  <th scope="col">Extra child tax rates</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td width={180}>
                    {infoExtraChildAdult?.Base
                      ? Number(infoExtraChildAdult?.Base.toFixed(2))
                      : 0}
                  </td>
                  <td width={180}>
                    {infoExtraChildAdult?.ExtraAdult
                      ? Number(infoExtraChildAdult?.ExtraAdult.toFixed(2))
                      : 0}
                  </td>
                  <td width={180}>
                    {infoExtraChildAdult?.ExtraChild
                      ? Number(infoExtraChildAdult?.ExtraChild.toFixed(2))
                      : 0}
                  </td>
                </tr>
              </tbody>
            </table>
          </>
        }
        footerBtnName="Close"
        handleSubmit={() => setExtraCloseModal(false)}
      />
    </>
  );
}